//External
import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { get_cookie } from "utils";
import { Link } from "./../../routes"; //Access routing

/*******************
  @Purpose : used for cms details
  @Parameter : { data}
  @Author : INIC
  *******************/
const cmsDetail = ({ data }) => {
  const [isMobileApp, setIsMobileApp] = useState();

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);
  return (
    <>
      {/* Banner : Start */}
      {isMobileApp !== "yes" && (
        <section className="common-banner">
          {/*
          Background Image - Generate dynamically
        */}
          <img src={data.featured_image} alt="" className="common-banner-bgi" />

          <div className="title-box text-center">
            <h1 className="title ff-poppins fw-regular text-white">
              {data?.title}
            </h1>
          </div>
        </section>
      )}
      {/* Banner : End */}

      {/* Common Content Block : Start */}
      <section className="common-content-section">
        <div className="custom-container">
          <div className="common-content-box">
            {ReactHtmlParser(
              data?.page_body?.replace(/\\n/g, "").replace(/\\r/g, "")
            )}
          </div>
        </div>
      </section>

      {/* Make Your Reservation :  Start  */}
      {data.slug === "about" && isMobileApp !== "yes" && (
        <section className="make-reservation text-center">
          <div className="custom-container">
            <div className="inner-wrapper">
              <p className="ff-hel-med text-black reservation-content">
                We are conveniently located in the heart of Beverly Hills, and
                our delivery service will drop your rental off anywhere within
                an eight-mile radius from our gallery. No matter the reason
                you’re visiting Los Angeles, Falcon Car Rental has the luxury
                car for you. Make your reservation today and experience our
                premier automobiles.
              </p>
              <Link href="/vehiclebooking">
                <a
                  className="btn btn-primary text-uppercase font-16"
                  title="Reserv Now"
                >
                  Make Your Reservation
                </a>
              </Link>
            </div>
          </div>
        </section>
      )}
      {/* Make Your Reservation :  End  */}
    </>
  );
};
export default cmsDetail;
